<!-- <p>notification-banner works!</p> -->
<div *ngIf="notifications.length" class="notificationbanner">
    @if (false) {
    <span class="navbar navbar-expand-lg bg-body-tertiary">
        <span>New Notifications</span>
        <span class="me-auto"></span>
        @if (info.length) {
        <mat-icon (click)="toggleView('info')" matTooltip="Toggle Info"
            [ngStyle]="{'color': showInfo ? 'blue' : 'grey'}">info</mat-icon>
        }
        @if (warnings.length) {
        <mat-icon (click)="toggleView('warn')" matTooltip="Toggle Warnings"
            [ngStyle]="{'color': showWarning ? 'orange' : 'grey'}">warning_amber</mat-icon>
        }
        @if (errors.length) {
        <mat-icon (click)="toggleView('error')" matTooltip="Toggle Errors"
            [ngStyle]="{'color': showError ? 'reg' : 'grey'}">error_outline</mat-icon>
        }
        @if (system.length) {
        <mat-icon (click)="toggleView('system')" matTooltip="Toggle System"
            [ngStyle]="{'color': showSystem ? 'reg' : 'grey'}">settings_applications</mat-icon>
        }
        @if (success.length) {
        <mat-icon (click)="toggleView('system')" matTooltip="Toggle Success"
            [ngStyle]="{'color': showSuccess ? 'reg' : 'grey'}">done</mat-icon>
        }
    </span>
    }
    <div style="display: flex;flex-direction: row;">
        @if (info.length && showInfo){
        <ng-container *ngTemplateOutlet="notificationTemplate; context: { $implicit: info }" />
        }
        @if (warnings.length && showWarning){
        <ng-container *ngTemplateOutlet="notificationTemplate; context: { $implicit: warnings }" />
        }
        @if (errors.length && showError){
        <ng-container *ngTemplateOutlet="notificationTemplate; context: { $implicit: errors }" />
        }
        @if (system.length && showSystem){
        <ng-container *ngTemplateOutlet="notificationTemplate; context: { $implicit: system }" />
        }
        @if (success.length && showSuccess){
        <ng-container *ngTemplateOutlet="notificationTemplate; context: { $implicit: success  }" />
        }
    </div>

</div>

<ng-template #notificationTemplate let-notifications:BannerNotification[]>
    <div class="notificationbanner">
        @for (n of notifications ; track $index ) {
        <span class="navbar navbar-expand-lg bg-body-tertiary" [ngClass]="{
            'notification-info': n.type === 'info',
            'notification-warning': n.type === 'warning',
            'notification-error': n.type === 'error',
            'notification-system': n.type === 'system',
            'notification-success': n.type === 'success'
            }">
            <span>{{n.message}}</span>
            <span class="me-auto"></span>
            @if (n.canCancel){
            <button type="button" mat-button (click)="dismiss(n.notificationUID)">x</button>
            }
            @if (n.canSnooze){
            <button type="button" mat-button (click)="snooze(n.notificationUID)"><mat-icon>snooze</mat-icon></button>
            }
        </span>
        }
    </div>
</ng-template>